import { decodeJwtPayload } from './decodeJwt'

// Dashboard is admin-only; beheerder/gebruiker belong in the portal.
export const tokenHasAdminRole = (token: string): boolean => {
  const payload = decodeJwtPayload<{ realm_access?: { roles?: string[] } }>(token)
  return (payload?.realm_access?.roles ?? []).includes('admin')
}
